import { TicketPriority } from '@/services/TicketsService';

export function getPriorityLabel(
  priority: TicketPriority | null | undefined,
  labels: Record<TicketPriority, string>,
) {
  if (!priority) {
    return '-';
  }

  return labels[priority] ?? '-';
}
